import React, {Fragment, useState} from 'react'
import axios from 'axios'
import DataCallerBaseComponent from '../Core/dataCallerBaseComponent'
import environment from "../../Environments/environments"
import ReactExport from "react-data-export"
import ReactTooltip from 'react-tooltip'
import { getBusyIndicator } from '../../Helpers/busyIndicator'
import Moment from 'moment'

// import "./journalSelectionsSnapshot.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export class JournalSelectionsSnapshotReport extends DataCallerBaseComponent {
    constructor(props) {
        super(props)

        this.state = {
            journalCounts: null,
            loading: false
        }

        this.reportTitle = 'Journal Selections Snapshot'
        this.todaysDate = new Date()
    }

    componentDidMount() {
        this.setState({loading: true}, () => this.loadDataFromServer())

        let footer = document.getElementById('Footer');
        footer.style.position = 'relative';
    }

    getExcelFunctionalButton() {
        return (
            <ExcelFile element={this.getExcelButton()} filename="JournalSelectionsSnapshot">
                <ExcelSheet data={this.state.journalCounts} name="JournalSelectionsSnapshot">
                    <ExcelColumn label="Journal" value="title"/>
                    <ExcelColumn label="Publisher" value="publisher"/>
                    <ExcelColumn label="# Selections" value="memberCount"/>
                </ExcelSheet>
            </ExcelFile>
        )
    }

    getExcelButton = () => {
        return (
            <button
                id = "table-xls-button"
                className = "download-table-xls-button"
            ></button>
        )
    }

    onDownload = () => {
        let button = document.getElementById('table-xls-button')
        button.click()
    }

    loadDataFromServer() {
        this.makeAPICall('/api/notificationsSnapshot/journalSelectionsSnapshot');
    }

    formatDate(date) {
        return Moment(date).format("MM/DD/YYYY hh:mm A");
    }

    makeAPICall(uri) {
        let url = environment.baseUrl.concat(uri)

        return axios.get(url, this.axiosHeaders)
            .then(response => {
                if (response.data.success === false) {
                    console.error('Error: ', response.data.message)
                    alert('Error getting Notifications data for the api: ' + uri + '. Error message: ' + response.data.message)
                    return;
                }
                else 
                {
                    this.setState({ journalCounts: response.data.data })
                }

                this.setState({ 
                    loading: false
                })
            })
            .catch(error => {
                console.log('Error: ', error)
                alert('An error occurred getting report data: ' + error)

                this.setState({
                    loading: false
                })
                return false;
            })
    }

    ellipsisFormat(longText) {
        if (!longText || longText.length <= 50) {
            return longText
        }

        return longText.substring(0, 50).trim() + ' . . .'
    }

    formatTooltip(text) {
        const tipPrefix = "<p style='text-align: left; width: 600px'>"
        const tipSuffix = '</p>'

        return tipPrefix + text + tipSuffix
    }

    CustomDataGrid = () => {
        const initialRows = this.state.journalCounts;
        if (initialRows != null && initialRows.length > 0)
        {
            return (
            <Fragment>
                {getBusyIndicator(this.state.loading, 
                    <div className="subject-selections-snapshot">
                    <ReactTooltip multiline={true}/>
                    <div className="TextContainer container">
                        <div className="title-section col-xs-12 text-center">
                            <div className="col-xs-12">
                                <div className="rbl-export-container">
                                    <span className="title-text">Journal Notifications</span>
                                    <br/><br/><br/>
                                    <span className="title-text">{this.reportTitle}</span>
                                    <br/><br/><br/>
                                    <span className="title-subtext">as of { this.formatDate(this.todaysDate) } (ET)</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="data-display">
                        <hr/>
                        <div>
                            <a className="export-link" onClick={this.onDownload}>Export to Excel</a>
                            {this.getExcelFunctionalButton()}
                        </div>
                        <div className="data-table">
                            <table id="data-table">
                                <thead>
                                    <tr className="table-head">
                                        <th>Journal</th>
                                        <th>Publisher</th>
                                        <th># Selections</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.journalCounts.map((item, index) => {
                                        let titleDisplay = this.ellipsisFormat(item.title)
                                        let titleTooltip = this.formatTooltip(item.title)
    
                                        let publisherDisplay = this.ellipsisFormat(item.publisher)
                                        let publisherTooltip = this.formatTooltip(item.publisher)

                                        return (
                                            <tr className="table-row" key={index}>
                                                {(item.title.length > 50) ?
                                                    <td>
                                                        <span data-tip={titleTooltip} data-html={true} data-multiline={false}>
                                                            {titleDisplay}
                                                        </span>
                                                    </td>
                                                :
                                                    <td>{item.title}</td>
                                                }
                                                {(item.publisher.length > 50) ?
                                                    <td>
                                                        <span data-tip={publisherTooltip} data-html={true} data-multiline={false}>
                                                            {publisherDisplay}
                                                        </span>
                                                    </td>
                                                :
                                                    <td>{item.publisher}</td>
                                                }
                                                <td>{item.memberCount}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </div>
                )}
            </Fragment>
            );
        }
        else
        {
            return null;
        }
    }

    render() {
        return (
        <this.CustomDataGrid />
    )}
}

const options = { 
    timeZone: "America/New_York", 
    hour12: true,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    //hour: 'numeric',
    //second: 'numeric',
    //minute: 'numeric'
};
